import { Component, Input } from '@angular/core';
import { Patient } from 'app/core/models/patient.model';
import { PatientInboundCallsComponent } from '../patient-inbound-calls/patient-inbound-calls.component';
import { PatientOutboundFaxesComponent } from '../../../shared/components/patient-outbound-faxes/patient-outbound-faxes.component';

@Component({
    selector: 'app-patient-communications',
    templateUrl: './patient-communications.component.html',
    styleUrls: ['./patient-communications.component.scss'],
    imports: [PatientInboundCallsComponent, PatientOutboundFaxesComponent]
})
export class PatientCommunicationsComponent {
  @Input() patient: Patient;
}
